import { render, staticRenderFns } from "./CalendarPeriodDetail.vue?vue&type=template&id=78ddb272&scoped=true"
import script from "./CalendarPeriodDetail.vue?vue&type=script&lang=js"
export * from "./CalendarPeriodDetail.vue?vue&type=script&lang=js"
import style0 from "./CalendarPeriodDetail.vue?vue&type=style&index=0&id=78ddb272&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78ddb272",
  null
  
)

export default component.exports